import React, { useState } from 'react';
import toast from 'react-hot-toast';
export default function Contact() {
  const [form, setForm] = useState({name:'',email:'',subject:'',message:''});
  const handleSubmit = e => { e.preventDefault(); toast.success('تم إرسال رسالتك بنجاح! سنتواصل معك قريباً 🎉'); setForm({name:'',email:'',subject:'',message:''}); };
  return (
    <div className="page-wrapper" style={{paddingBottom:60}}>
      <div style={{background:'linear-gradient(135deg,#0D1421 0%,#0a2a4a 50%,#0D1421 100%)',padding:'60px 20px',textAlign:'center'}}>
        <div style={{fontSize:40,marginBottom:12}}>💬</div>
        <h1 style={{fontSize:34,fontWeight:800,marginBottom:12}}>تواصل معنا</h1>
        <p style={{color:'var(--color-text-muted)',fontSize:15}}>نحن هنا للمساعدة — تواصل معنا في أي وقت</p>
      </div>
      <div className="container" style={{maxWidth:900,paddingTop:48}}>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1.5fr',gap:24}}>
          <div>
            {[
              {i:'📧',t:'البريد الإلكتروني',d:'info@sportix.ae'},
              {i:'📞',t:'الهاتف',d:'+971 50 000 0000'},
              {i:'📍',t:'العنوان',d:'دبي، الإمارات العربية المتحدة'},
              {i:'🕐',t:'ساعات العمل',d:'الأحد - الخميس: 9 صباحاً - 6 مساءً'},
            ].map((c,i)=>(
              <div key={i} className="card" style={{padding:20,marginBottom:12,display:'flex',gap:16,alignItems:'flex-start'}}>
                <div style={{fontSize:28,flexShrink:0}}>{c.i}</div>
                <div>
                  <div style={{fontWeight:700,fontSize:14,marginBottom:4}}>{c.t}</div>
                  <div style={{color:'var(--color-text-muted)',fontSize:13}}>{c.d}</div>
                </div>
              </div>
            ))}
            <div className="card" style={{padding:20,marginTop:8}}>
              <div style={{fontWeight:700,fontSize:14,marginBottom:12}}>🌐 تابعنا على</div>
              <div style={{display:'flex',gap:12}}>
                {['Twitter','LinkedIn','Instagram'].map((s,i)=>(
                  <span key={i} style={{padding:'6px 14px',background:'rgba(0,212,255,0.1)',border:'1px solid rgba(0,212,255,0.2)',borderRadius:20,fontSize:12,color:'var(--color-primary)',cursor:'pointer'}}>{s}</span>
                ))}
              </div>
            </div>
          </div>
          <div className="card" style={{padding:32}}>
            <h3 style={{fontSize:18,fontWeight:700,marginBottom:24}}>أرسل لنا رسالة</h3>
            <form onSubmit={handleSubmit}>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16,marginBottom:16}}>
                <div className="form-group"><label className="form-label">الاسم</label><input className="form-input" placeholder="اسمك الكامل" value={form.name} onChange={e=>setForm(p=>({...p,name:e.target.value}))} required /></div>
                <div className="form-group"><label className="form-label">البريد الإلكتروني</label><input type="email" className="form-input" placeholder="email@example.com" value={form.email} onChange={e=>setForm(p=>({...p,email:e.target.value}))} required /></div>
              </div>
              <div className="form-group" style={{marginBottom:16}}>
                <label className="form-label">الموضوع</label>
                <select className="form-select" value={form.subject} onChange={e=>setForm(p=>({...p,subject:e.target.value}))} required>
                  <option value="">اختر الموضوع</option>
                  <option>استفسار عام</option>
                  <option>مشكلة تقنية</option>
                  <option>شراكة أعمال</option>
                  <option>الإبلاغ عن مشكلة</option>
                  <option>اقتراح أو ملاحظة</option>
                </select>
              </div>
              <div className="form-group" style={{marginBottom:24}}>
                <label className="form-label">الرسالة</label>
                <textarea className="form-textarea" rows="5" placeholder="اكتب رسالتك هنا..." value={form.message} onChange={e=>setForm(p=>({...p,message:e.target.value}))} required style={{minHeight:130}} />
              </div>
              <button type="submit" className="btn btn-primary" style={{width:'100%',padding:'14px',fontSize:16}}>إرسال الرسالة 📨</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
